module.exports = __webpack_public_path__ + "static/media/18_2.ff45426b.png";